import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';
import { IStructure } from '../model/structure.model';
import { Observable, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { IDdcUser } from '../model/ddc-user.model';
import { TypeProjetAnneeEnum } from "../constant/enum";

@Component({
    selector: 'ddc-structure-selector',
    templateUrl: './structure-selector.component.html',
    styleUrls: ['./structure-selector.component.scss'],
    standalone: false
})
export class StructureSelectorComponent implements OnInit {

  filteredStructures$: Observable<IStructure[]>;

  @Input() resetStructure?: Subject<boolean>;

  @Input() set control(structureFormControl: UntypedFormControl) {
    this._structureFormControl = structureFormControl;
  }

  @Input() set isRequired(isRequired: boolean) {
    this._isRequired = isRequired;
  }

  @Input() set labelKey(labelKey: string) {
    this._labelKey = labelKey;
  }

  @Input() set structures(structures: IStructure[]) {
    this._structures = structures;
    if(this._structureFormControl != null){
      this.setStructureByDefault();
    }
  }

  @Input() set defaultStructure(defaultStructure: IStructure) {
    this._defaultStructure = defaultStructure;
  }

  @Output() typeStructure = new EventEmitter();
  @Output() codeStructure = new  EventEmitter();

  _structureFormControl: UntypedFormControl;
  _isRequired: boolean;
  _labelKey: string;
  _structures: IStructure[];
  _defaultStructure: IStructure;

  constructor(
    protected authenticationService: AuthenticationService,
  ) {
  }

  ngOnInit(): void {
    if(this.resetStructure){
      this.resetStructure.subscribe(v => { 
        this.setStructureByDefault();
      });
    }
    this.setStructureByDefault();
    this.filteredStructures$ = this._structureFormControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        if(value && typeof value == "object"){
          let typeStructure = this.isGoupeOrTerritoire(value.code)
          this.typeStructure.emit(typeStructure);
          let codeStructure = value.code
          this.codeStructure.emit(codeStructure)
        }
        return this.filterStructures(value)
      })
    );
  }

  filterStructures(value: any): IStructure[] {
    if (value && value.libelle) {
      const regexExp = new RegExp(`${value.libelle}`, 'gi');
      return this._structures.filter((structure: IStructure) => structure.libelle.match(regexExp));
    }

    if (value && value.length >= 3) {
      const regexExp = new RegExp(`${value}`, 'gi');
      return this._structures.filter((structure: IStructure) => structure.libelle.match(regexExp) || structure.code.match(regexExp));
    }

    return this._structures;
  }

  setStructureByDefault() {
    const currentUser: IDdcUser = this.authenticationService.currentUserValue;
    if (this._defaultStructure) {
      this._structureFormControl.setValue(this._defaultStructure);
      this._structureFormControl.updateValueAndValidity({emitEvent: true, onlySelf: true});
    } else if (currentUser && currentUser.selectedFunctionality) {
      const structure = this._structures.find((structure: IStructure) => structure.code === currentUser.selectedFunctionality.codeStructure)
      if(structure) {
        let typeStructure = this.isGoupeOrTerritoire(structure.code)
        this.typeStructure.emit(typeStructure);
        this._structureFormControl.setValue(structure);
        this._structureFormControl.updateValueAndValidity({emitEvent: true, onlySelf: true});
      }
    }
  }

  displayStructureName(value?: IStructure): string {
    if (value) {
      return value.libelle;
    }
    return null;
  }

  isGoupeOrTerritoire(structure) {
    if(structure && structure.length > 0) {
      let structureArray = structure.split('');
      if(structureArray[0] == '9') {
        return TypeProjetAnneeEnum.CAMP_TERRITOIRE
      }
      if((structureArray[5] == '0') && (structureArray[6] == '0') && (structureArray[7] == '0')) {
        return TypeProjetAnneeEnum.CAMP_TERRITOIRE
      }
      if((structureArray[7] != '0') && (structureArray[8] == '0') && (structureArray[9] == '0')) {
        return TypeProjetAnneeEnum.CAMP_GROUPE
      }
      return TypeProjetAnneeEnum.CAMP_GROUPE
    }
  }

}
